import script from "./ModalOrderHold.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalOrderHold.vue?vue&type=script&setup=true&lang=ts"

import "./ModalOrderHold.vue?vue&type=style&index=0&id=b436f68e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b436f68e"]])

export default __exports__